import { ReactComponent as GreaterThanSvg } from "assets/Svgs/GreaterThan.svg";

import { ReactComponent as CachedIcons } from "assets/Svgs/CachedIcons.svg";
import { ReactComponent as TimeLapseSvg } from "assets/Svgs/TimeLapse.svg";
import { ReactComponent as VectorSvg } from "assets/Svgs/Vector.svg";
import { ReactComponent as SpaceDashboardSvg } from "assets/Svgs/SpaceDashboard.svg";
import { ReactComponent as OvenGenSvg } from "assets/Svgs/OvenGen.svg";
import { ReactComponent as SystemUpdateSvg } from "assets/Svgs/SystemUpdate.svg";
import { ReactComponent as FilledTimeSvg } from "assets/Svgs/FilledTime.svg";

import { ReactComponent as ReportFilterSvg } from "assets/Svgs/ReportFilter.svg";

import { TextIcon } from "247factorynet-packages";
import i18n from "i18n/i18n";
import moment from "moment";
import { Link } from "react-router-dom";
import { useBoundStore } from "store/store";
import { useEffect, useState } from "react";
import "moment/locale/de"; // Import German (de) locale data for Moment.js

import { ReactComponent as GrayDotSvg } from "assets/Svgs/GrayDot.svg";
import { getSvgByReportConfigType } from "utils/helper";
import { getReportConfigLastTime } from "shared-functions/notification";

function ReportListing(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  const siteData: any = useBoundStore((state) => state.subscribedSites);
  const [sites, setSites] = useState("");
  const [sitesNodeIds, setSitesNodeIds] = useState<string[]>([]);
  const [areasNodeIds, setAreasNodeIds] = useState<string[]>([]);
  const [areas, setAreas] = useState("");
  const [equipmentsNodeIds, setEquipmentsNodeIds] = useState<string[]>([]);
  const [equipments, setEquipments] = useState("");
  const [exportSettings, setExportSettings] = useState("");

  useEffect(() => {

    // Total number of areas and equipments
    let totalAreas = 0;
    let totalEquipments = 0;
    let totalSites = 0;

    // All Sites Selected
    if (props?.report?.reportconfiguration?.allsites) {
      setEquipments(i18n(lang)?.all_devices);
    }

    // Single Site Selected
    else if (
      props?.report?.reportconfiguration?.hassite?.length === 1 &&
      !props?.report?.reportconfiguration?.hasarea
    ) {
      // Get the selected site
      const selectedSite = props?.report?.reportconfiguration?.hassite[0];
      const siteId = selectedSite?.site.nodeid;

      // Set sites to "Werk 1"
      setSites("Werk 1");

      // Count areas and equipments in the selected site
      const selectedSiteData = siteData[siteId];
      if (selectedSiteData?.hasarea) {
        selectedSiteData.hasarea.forEach((area: any) => {
          totalAreas++;
          if (area?.area?.hasequipment) {
            // If hasequipment is an array of objects containing equipment data
            area?.area?.hasequipment.forEach((equipment: any) => {
              totalEquipments++; // Increment totalEquipments for each equipment in the area
            });
          }
        });
      }
      setAreas(i18n(lang)?.areas + ` (${totalAreas.toString()})`);
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    }

    // Multiple Sites Selected
    else if (props?.report?.reportconfiguration?.hassite?.length > 1) {
      // Set sites to the number of selected sites
      const numSites = props?.report?.reportconfiguration?.hassite?.length || 0;
      setSites(numSites.toString());

      // Count areas and equipments across all selected sites
      props?.report?.reportconfiguration?.hassite?.forEach((site: any) => {
        const siteId = site?.site.nodeid;
        const currentSiteData = siteData[siteId]; // Rename siteData to avoid conflict
        if (currentSiteData?.hasarea) {
          currentSiteData.hasarea.forEach((area: any) => {
            totalAreas++;
            if (area?.area?.hasequipment) {
              totalEquipments += area?.area?.hasequipment.length;
            }
          });
        }
      });

      // Set areas and equipments
      setAreas(i18n(lang)?.areas + ` (${totalAreas.toString()})`);
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    } else if (
      props?.report?.reportconfiguration?.hasarea &&
      props?.report?.reportconfiguration?.hassite
    ) {
      // Iterate over hasareas
      props?.report?.reportconfiguration?.hasarea.forEach((areaItem: any) => {
        // Check if siteData has the corresponding hasarea nodeid
        const areaNodeId = areaItem?.area.nodeid;
        const areaData: any = Object.values(siteData).find((site: any) =>
          site.hasarea.find((area: any) => area.area.nodeid === areaNodeId)
        );

        if (areaData) {
          totalSites++; // Increment totalSites

          // Count areas and equipments inside the area
          if (areaData.hasarea) {
            totalAreas += areaData.hasarea.length; // Increment totalAreas by the number of areas
            areaData.hasarea.forEach((area: any) => {
              if (area?.area?.hasequipment) {
                totalEquipments += area?.area?.hasequipment.length; // Increment totalEquipments by the number of equipments in each area
              }
            });
          }
        }
      });
      props?.report?.reportconfiguration?.hassite.forEach((siteItem: any) => {
        // Check if siteData has the corresponding site nodeid
        const siteNodeId = siteItem?.site.nodeid;
        const siteDataItem = siteData[siteNodeId];

        if (siteDataItem) {
          totalSites++; // Increment totalSites

          // Count areas and equipments inside the site
          if (siteDataItem.hasarea) {
            totalAreas += siteDataItem.hasarea.length; // Increment totalAreas by the number of areas in the site
            siteDataItem.hasarea.forEach((area: any) => {
              if (area?.area?.hasequipment) {
                totalEquipments += area?.area?.hasequipment.length; // Increment totalEquipments by the number of equipments in each area
              }
            });
          }
        }
      });

      setSites(totalSites.toString());
      setAreas(i18n(lang)?.areas + ` (${totalAreas.toString()})`);
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    } else if (
      props?.report?.reportconfiguration?.hasarea &&
      !props?.report?.reportconfiguration?.hassite
    ) {
      // Check if siteData has the corresponding hasarea nodeid
      Object.keys(siteData).forEach((key) => {
        if (
          siteData[key]?.hasarea &&
          props?.report?.reportconfiguration?.hasarea
        ) {
          siteData[key].hasarea.forEach((area: any) => {
            // Use forEach instead of map
            props?.report?.reportconfiguration?.hasarea.forEach(
              (element: any) => {
                if (area.area.nodeid === element.area?.nodeid) {
                  totalAreas++;
                  area.area?.hasequipment?.forEach((element: any) => {
                    totalEquipments++;
                  });
                }
              }
            );
          });
        }
      });

      setSites(totalSites.toString());
      setAreas(i18n(lang)?.areas + ` (${totalAreas.toString()})`);
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    } else {
      setSites(totalSites.toString());
      setAreas(i18n(lang)?.areas + ` (${totalAreas.toString()})`);
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    }

    if(props?.report?.reportconfiguration?.hasequipment){
      totalEquipments = totalEquipments + props?.report?.reportconfiguration?.hasequipment.length;
      setEquipments(i18n(lang)?.devices + ` (${totalEquipments.toString()})`);
    }

    //export setting
    if (props?.report?.reportconfiguration?.exportsettings === "all") {
      setExportSettings(i18n(lang)?.per_all);
    } else if (props?.report?.reportconfiguration?.exportsettings === "site") {
      setExportSettings(i18n(lang)?.per_site);
    } else if (props?.report?.reportconfiguration?.exportsettings === "area") {
      setExportSettings(i18n(lang)?.per_area);
    } else if (
      props?.report?.reportconfiguration?.exportsettings === "equipment"
    ) {
      setExportSettings(i18n(lang)?.per_equipment);
    }
  }, [siteData, props?.report?.reportconfiguration]);

  function getDateByRepititionInterval(date: any, repetitioninterval: any) {

  
    let formattedDate;
    // Extract time part from the date
    const timePart = moment(date)
      .locale(lang === "en" ? "es" : "de")
      .format("HH:mm");
    const dayOfMonth = moment(date)
      .locale(lang === "en" ? "es" : "de")
      .format("DD"); // Extract day of month

    switch (repetitioninterval) {
      case "1w":
        // For weekly repetition, include the extracted time
        formattedDate = `${i18n(lang).repition_weekly} (${
          moment(date)
                .locale(lang === "en" ? "es" : "de")
                .format("dd")
        }), ${timePart} Uhr`;
        break;
      case "1d":
        // For daily repetition, include the extracted time
        formattedDate = `${i18n(lang).repition_daily}, ${timePart} Uhr`;
        break;
      case "1m":
        // For monthly repetition, add 1 month to the date
        // Note: This will not change the time, so if you want to format it differently, adjust here
        formattedDate = `${i18n(lang).repition_monthly}, ${timePart} Uhr`;

        break;
      default:
        // Default to just formatting the date if the interval isn't recognized
        formattedDate = moment(date)
          .locale(lang === "en" ? "es" : "de")
          .format("dddd, HH:mm");
    }

    return formattedDate;
  }


  let reportType = props.report.reportconfiguration.triggertype;

  let triggerType = props.report.reportconfiguration.triggeringevent;

  return (
    <div style={{ margin: "0px 24px 16px 24px" }}>
      <div className="reportListing">
        <div className="contentWrapper">
          <div className="content" style={{ width: "95%" }}>
            <div className="title">
              <div className="flickSvg">
                 {getSvgByReportConfigType(reportType)}
              </div>

              <div>{props?.report?.reportconfiguration.title}</div>
              <div className="grayDot">
                <GrayDotSvg />{" "}
              </div>
              <div className="manual-text">{ reportType === "event" ? (triggerType === "onnewproduct" ? i18n(lang).event_listing_1 : i18n(lang).event_listing_2) : (reportType === "time" || reportType === "")  ? getDateByRepititionInterval(props.report.reportconfiguration.startingfrom,props.report.reportconfiguration.repetitioninterval) : "" }</div>
            </div>
            <div className="iconsSet">
              <TextIcon
                icon={<FilledTimeSvg />}
                iconText={(reportType === "time" || reportType === "") ? <span style={{ textTransform: "capitalize"}}>{i18n(lang).last + "  " + getReportConfigLastTime( props?.report?.reportconfiguration?.lastexecutedat,lang)}</span> : (triggerType === "onnewproduct" ? i18n(lang).last_product_pr : i18n(lang).last_product_br) }
                className=""
              />
              
              <TextIcon
                icon={<VectorSvg />}
                iconText={
                  props?.report?.reportconfiguration?.allsites
                    ? i18n(lang)?.all_sites
                    : i18n(lang)?.sites +
                      `(${
                        Array.isArray(
                          props?.report?.reportconfiguration?.hassite
                        ) &&
                        props?.report?.reportconfiguration?.hassite.length > 0
                          ? props?.report?.reportconfiguration?.hassite.length
                          : "0"
                      })`
                }
                className=""
              />
              <TextIcon
                icon={<SpaceDashboardSvg />}
                iconText={areas}
                className=""
              />
              <TextIcon
                icon={<OvenGenSvg />}
                iconText={equipments}
                className=""
              />
              <TextIcon
                icon={<SystemUpdateSvg />}
                iconText={exportSettings}
                className=""
              />
              { reportType === "manual" ? 
                <TextIcon
                icon={<ReportFilterSvg />}
                iconText={props?.report?.reportconfiguration?.filterbyproduct}
                className=""
              /> : ""
              }
            </div>
          </div>
          <div className="svg">
            <Link
              to="/report-detail"
              state={{
                report: props.report,
                areas: areas,
                equipments: equipments,
                exportSettings: exportSettings,
                reportType: reportType
              }}
            >
              <GreaterThanSvg />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportListing;
